import { trimEnd } from 'lodash';
import { Node_Type } from '@wix/ricos';
import { POST_SEO_DESCRIPTION_MAXLENGTH } from '../../constants';
import { getRichContentPostVideoEmbedCover } from '../../services';
import { getMultilingualQueryParam } from '../../services/get-multilingual-query-param';
import { getRichContentText } from '../../services/get-rich-content-text';
import { getRichContentPostCover } from '../../services/post-cover-utils';
export { getPostImageCover } from '../../services/post-cover-utils';
export const getPostCover = (post, imageHost, videoHost) => {
    return imageHost && videoHost && post.content
        ? getRichContentPostCover({ content: post.content }, imageHost, videoHost)
        : post?.coverImage ?? {};
};
export const getPostVideoEmbedCover = (post, imageHost, videoHost) => {
    const postContent = post.content ?? {};
    return getRichContentPostVideoEmbedCover(postContent, imageHost, videoHost);
};
export const getPostExcerpt = ({ excerpt, content, }) => {
    if (excerpt) {
        return excerpt.substring(0, POST_SEO_DESCRIPTION_MAXLENGTH);
    }
    return getRichContentText({
        ...content,
        nodes: content.nodes.filter((node) => node.type !== Node_Type.IMAGE),
    }).substring(0, POST_SEO_DESCRIPTION_MAXLENGTH);
};
export const getPostSeoDescription = ({ content, excerpt, seoDescription, }) => (seoDescription || getPostExcerpt({ excerpt, content })).substring(0, POST_SEO_DESCRIPTION_MAXLENGTH);
export const getCanonicalPostUrl = ({ post, postPageSectionUrl, customPostUrl, multilingual, }) => {
    if (customPostUrl) {
        const langParam = multilingual ? getMultilingualQueryParam(multilingual) : '';
        return `${customPostUrl}${langParam}`;
    }
    if (post.url) {
        return `${post.url.base}${post.url.path}`;
    }
    if (post.canonicalUrl) {
        return post.canonicalUrl;
    }
    return `${trimEnd(postPageSectionUrl, '/')}/${post.slug}`;
};
//# sourceMappingURL=post-selectors.js.map